import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #f3f4f6;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 700px;
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  h1 {
    font-size: 22px;
  }
`;

export const ImagesContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;


`;

export const Image = styled.img`
  width: 100%;
  height: 300px;
  object-fit: cover; 
  border-radius: 12px;
  margin-bottom: 20px; 
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const Item = styled.div`
  background: #f9fafb;
  padding: 12px;
  border-radius: 10px;

  span {
    font-size: 12px;
    color: #6b7280;
  }

  strong {
    display: block;
    font-size: 16px;
    margin-top: 4px;
  }
`;

interface StatusProps {
  $status: string;
}

export const Status = styled.span<StatusProps>`
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: bold;

  background: ${(props) =>
    props.$status === "Concluído" ? "#dcfce7" : "#fef3c7"};

  color: ${(props) =>
    props.$status === "Concluído" ? "#166534" : "#92400e"};
`;